export default __webpack_public_path__ + "static/media/logo_white.42ec2704.png";